import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import constants from '@common/constants';

import { getCookie, removeCookie } from '@libs/utils/helpers/getSafeCookies';

export function useAtendeAuth() {
  const { search } = useLocation();
  const atendeLoginData = new URLSearchParams(search).get('atende');

  useEffect(() => {
    if (atendeLoginData) return;

    const rlTracksAuth = getCookie(constants.redline.rl_tracks_auth, true);
    const rlTracksAuthData = rlTracksAuth ? JSON.parse(rlTracksAuth) : null;
    if (rlTracksAuthData?.authenticationType === 'atende-sign-in') {
      removeCookie(constants.redline.rl_tracks_auth);
    }
    removeCookie('ATENDE_SIGNUP');
  }, [atendeLoginData]);
}
